import React from "react";

import { CheckableInputLabel } from "emoreg/atoms/checkable-input-label";
import { FieldContainer } from "emoreg/atoms/field-container";
import { InputMessage } from "emoreg/atoms/input-message";
import { SubLabel } from "emoreg/atoms/Inputs/common";
import { InputPillContainer } from "emoreg/atoms/pill-container";
import { RadioInput, RadioInputProps } from "emoreg/atoms/radio-input";
import { Box, Flex } from "emoreg/layouts";
import { isTruthy } from "hassibot/util/guards";

import { RadioColor } from "./types";

export type RadioPillProps<T extends string> = RadioInputProps<T> & {
  label: string | JSX.Element;
  subLabel?: string;
  error?: string;
  color?: RadioColor;
};

export const RadioPill = React.forwardRef<HTMLInputElement, RadioPillProps<string>>(
  ({ style, className, label, id, color, error, hasError, subLabel, ...props }, ref) => {
    return (
      <FieldContainer style={style} className={className}>
        <Box>
          <CheckableInputLabel color={color} htmlFor={id}>
            <InputPillContainer hasError={hasError || !!error} color={color}>
              <Flex gap={8} alignItems="center">
                <RadioInput
                  ref={ref}
                  id={id}
                  {...props}
                  hasError={hasError || !!error}
                  aria-labelledby={[props["aria-labelledby"], !!error && `error_${id}`]
                    .filter(isTruthy)
                    .join(" ")}
                />
                <Flex gap={4} direction="column" grow={1}>
                  {label}
                  {subLabel && <SubLabel>{subLabel}</SubLabel>}
                </Flex>
              </Flex>
            </InputPillContainer>
          </CheckableInputLabel>
        </Box>
        {error && (
          <InputMessage variant="error" id={`error_${id}`}>
            {error}
          </InputMessage>
        )}
      </FieldContainer>
    );
  }
);
